module.exports = __webpack_public_path__ + "img/product-4.21e8c993.jpg";